import { getAccountApi } from '../../api/account';
import { getBlockchainTransactionsList } from '../../api/transaction';
import { errorNotification } from '../../helpers/notification';
import { GetState, ThunkAppDispatch } from '../../store';
import { setBurningAccountAction, setBurningTransactions } from './action';
import { getBurningTransactionsSelector } from './selectors';

export const mainThunk = () => (dispatch: ThunkAppDispatch, getState: GetState) => {
  getBlockchainTransactionsList({
    account: 'APL-MRCC-2YLS-8M54-3CMAJ',
    firstIndex: 0,
    lastIndex: 15,
  })
    .then((res) => {
      dispatch(setBurningTransactions(res));
    })
    .catch(() => {
      errorNotification('Getting burning transactions has been failed.');
    });

  getAccountApi({
    account: 'APL-MRCC-2YLS-8M54-3CMAJ',
  })
    .then((res) => {
      dispatch(setBurningAccountAction(res));
    })
    .catch(() => {
      errorNotification('Getting burning account has been failed.');
    });
};
